import { useState } from "react";
import { GetUser, UpdateUser, DeviceRegistration } from "../service/SpatApi";  // Import the API function
import checkInternetConnection from "../utils/CheckInternetConnection";
import { showErrorToast, showSuccessToast } from "../utils/Toasts";
import { updateUserData } from "../redux/slice/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { detectFeatures } from '../utils/biometricUtils';
import { requestForToken } from '../messaging/firebaseMessaging';

export function useUser() {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");  // State to hold error message
  const [userData, setUserData] = useState(null);  // State to store user data
  const dispatch = useDispatch();
  const currentEmail = useSelector((state) => state.user.email);  // Assuming you have email in the user slice

  // Function to fetch user data
  const getUser = async (email) => {
    if (!checkInternetConnection()) {
      showErrorToast("இணைய இணைப்பு இல்லை!");
      return;
    }

    setLoading(true);
    setErrorMessage("");  // Clear any previous error messages

    try {
      const response = await GetUser(email);  // Fetch the user data using the email and token

      if (response?.status === 200 || response?.status === 201) {
        if (response.data.user.email === currentEmail) {
          setUserData(response.data);  // Store the user data
          dispatch(updateUserData({
            firstName: response.data.user.firstName,
            //mobileVerification: response.data.user.mobileVerification,
            roles: response.data.user.roles || [],

            email: response.data.user.email,
            isLoggedIn: true,

          }));
          if (response.data.user.deviceTokenExists === false) {
            try {
              const {
                platform,
                source,
                location
              } = await detectFeatures(true);
              const deviceNotificationRegistration = await requestForToken();
              await DeviceRegistration(
                JSON.stringify(
                  {
                    deviceInfo: {
                      platform,
                      source,
                      location
                    },
                    deviceNotificationRegistration
                  }
                )
              );

            }
            catch (error) {
              console.error('Error while calling DeviceRegistration' + error);
            }
          }
        }
      } else if (response?.status === 401 || response?.status === 403) {

        showErrorToast("பயனர் அங்கீகரிக்கப்படவில்லை.");

      } else if (response?.status === 600) {
        showErrorToast("பல முயற்சிகளுக்குப் பிறகும் அங்கீகரிக்க முடியவில்லை...");
      } else {
        setErrorMessage("பயனர் தரவைப் பெறுவதில் தோல்வி...");
      }
    } catch (error) {
      setErrorMessage("பயனர் தரவைப் பெறுவதில் தோல்வி...");
    } finally {
      setLoading(false); // Set loading state to false once data is fetched
    }
  };

  // Function to update user details
  const updateUser = async (updatedUserData) => {
    if (!checkInternetConnection()) {
      showErrorToast("இணைய இணைப்பு இல்லை!");
      return;
    }

    setLoading(true);
    setErrorMessage("");  // Clear previous error messages

    try {

      const response = await UpdateUser(updatedUserData);  // Call the update API with updated user data

      if (response?.status === 200 || response?.status === 201) {
        showSuccessToast("கணக்கு புதுப்பிக்கப்பட்டது");  // Show success toast
        setUserData({ ...userData, ...updatedUserData });  // Update the local user data
      } else if (response?.status === 401 || response?.status === 403) {

        showErrorToast("பயனர் அங்கீகரிக்கப்படவில்லை.");

      } else {
        showErrorToast("புதுப்பிப்பில் பிழை ஏற்பட்டது");  // Show error message
      }
    } catch (error) {
      showErrorToast("புதுப்பிப்பில் பிழை ஏற்பட்டது");
    } finally {
      setLoading(false);  // Set loading state to false after the update attempt
    }
  };

  return {
    getUser,
    updateUser,   // Expose the updateUser function
    loading,
    errorMessage,
    userData,
  };
}
